export const DEFAULT_API_ERROR_CODE = "e999";
